module.exports = __webpack_public_path__ + "img/banner.ac3d49e0.png";